import { createReducer } from '@reduxjs/toolkit';

import patchArticles, { clearArticlesUpdate } from '../../thunks/articles/patchArticles';

const initialState = {
  loading: false,
  error: '',
  data: null,
};

const patchArticlesReducer = createReducer(initialState, {
  [patchArticles.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [patchArticles.fulfilled]: (state, { payload: data }) => ({
    ...state,
    loading: false,
    data,
  }),
  [clearArticlesUpdate]: () => initialState,
  [patchArticles.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
    data: null
  }),
});

export default patchArticlesReducer;
